// src/pages/ContractorManagement.jsx
import React from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Input,
  InputGroup,
  InputGroupText,
  Table,
  CardBody,
  Card,
} from "reactstrap";
import {
  FiUserCheck,
  FiUserPlus ,
  FiClock,
  FiBriefcase,
  FiSearch,
  FiFilter,
  FiDownload,
  
} from "react-icons/fi";
import { IoLocationOutline } from "react-icons/io5";

import StatCard from "../contractormanagement/StatCard";
import'./Constarctor.css'

function ContractorManagement() {
  /* ---------- static demo data ---------- */
  const statCards = [
    {
      title: "Currently Inside",
      value: 3,
      subtitle: "Active contractors",
      color: "#14A44D",
      icon: IoLocationOutline ,
    },
    {
      title: "Total Today",
      value: 4,
      subtitle: "Unique contractors",
      color: "#1D67AA",
      icon: FiClock,
    },
    {
      title: "Avg Duration",
      value: "3h 22m",
      subtitle: "Per contractor",
      color: "#8B3DFF",
      icon: FiClock,
    },
    {
      title: "Active Projects",
      value: 4,
      subtitle: "Ongoing work",
      color: "#FF6B00",
      icon: FiUserPlus ,
    },
  ];

  const contractors = [
    {
      id: 1,
      name: "Mike Wilson",
      phone: "+1 (555) 123‑4567",
      company: "BuildTech Solutions",
      project: "Office Renovation",
      status: "Inside",
      entry: "08:30 AM",
      exit: "-",
      duration: "2h 45m",
      badge: "CT001",
    },
    {
      id: 2,
      name: "Sarah Davis",
      phone: "+1 (555) 234‑5678",
      company: "ElectroMax Inc",
      project: "Electrical Upgrade",
      status: "Inside",
      entry: "09:15 AM",
      exit: "-",
      duration: "2h 00m",
      badge: "CT002",
    },
    {
      id: 3,
      name: "John Martinez",
      phone: "+1 (555) 345‑6789",
      company: "PlumbPro Services",
      project: "Plumbing Maintenance",
      status: "Exited",
      entry: "07:00 AM",
      exit: "10:30 AM",
      duration: "3h 30m",
      badge: "CT003",
    },
    {
      id: 4,
      name: "Lisa Chen",
      phone: "+1 (555) 456‑7890",
      company: "CleanCorp",
      project: "Facility Cleaning",
      status: "Inside",
      entry: "06:00 AM",
      exit: "-",
      duration: "5h 15m",
      badge: "CT004",
    },
  ];

  /* ---------- helpers ---------- */
  const statusPill = (label) => {
    const isInside = label === "Inside";
    return (
      <span
        style={{
          display: "inline-block",
          padding: "2px 12px",
          fontSize: "12px",
          fontWeight: 600,
          color: "#fff",
          backgroundColor: isInside ? "#14A44D" : "#AEB5BC",
          borderRadius: "12px",
          minWidth: 60,
          textAlign: "center",
          
        }}
      >
        {label}
      </span>
    );
  };

  return (
    <Container fluid={true} >
      <br />
      {/* top bar */}
      <Row
        style={{
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <Col>
          <h1
            style={{
              fontSize: 24,
              fontWeight: 600,
              color: "#1D67AA",
              margin: 0,
            }}
          >
            Contractor Management
          </h1>
          <p
            style={{
              fontSize: 14,
              color: "#535353",
              marginTop: 4,
            }}
          >
            2025 ‑ Week 26
          </p>
        </Col>

        <Col
          xs="auto"
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
           <button
      className="expobtn"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        fontSize: 14,
        border: "1px solid #E5E7EB",
        borderRadius: 6,
        padding: "6px 14px",
        color: "#1D67AA",      // ← text + icon blue
        background: "transparent", // optional: keep background clear
        fontWeight:"500"
      }}
    >
      <FiDownload size={14} />
      Export Report
    </button>
        </Col>
      </Row>

      {/* metric cards */}
      <Row
        style={{
          gap: 16,
          marginBottom: 24,
        }}
      >
        {statCards.map((card) => (
          <Col
            key={card.title}
            xs={12}
            sm={6}
            md={3}
            style={{ minWidth: 220, flex: "1 1 0" }}
          >
            <StatCard {...card} Icon={card.icon} />
          </Col>
        ))}
      </Row>

      {/* search + filter */}
      <Row style={{ gap: 16, marginBottom: 24 }}>
        <Col xs={12} md>
          <InputGroup>
            <InputGroupText
              style={{
                background: "#fff",
                border: "1px solid #E5E7EB",
                borderRight: 0,
                paddingLeft: 12,
              }}
            >
              <FiSearch size={16} />
            </InputGroupText>
            <Input
              placeholder="Search contractors, companies, or projects..."
              style={{
                border: "1px solid #E5E7EB",
                borderLeft: 0,
                fontSize: 14,
                padding: "8px 12px",
                borderRadius: "0 6px 6px 0",
              }}
            />
          </InputGroup>
        </Col>

        <Col xs={12} md="auto">
          <InputGroup>
            <InputGroupText
              style={{
                background: "#fff",
                border: "1px solid #E5E7EB",
                borderRight: 0,
                paddingLeft: 12,
              }}
            >
              <FiFilter size={16} />
            </InputGroupText>
            <Input
              type="select"
              style={{
                border: "1px solid #E5E7EB",
                borderLeft: 0,
                fontSize: 14,
                padding: "8px 38px 8px 12px",
                borderRadius: "0 6px 6px 0",
                appearance: "none",
              }}
            >
              <option>All Status</option>
              <option>Inside</option>
              <option>Exited</option>
            </Input>
          </InputGroup>
        </Col>
      </Row>



      {/* contractor table............................................................ */}
      <Card>
        <CardBody>

       
      <h4
        style={{
          fontSize: 24,
          fontWeight: 600,
          color: "#1D67AA",
          marginBottom: 12,
        }}
      >
        Contractor Activity ({contractors.length})
        
      </h4>

     <Card
  style={{
    border: "1px solid #E5E7EB",
    borderRadius: 6,
    marginBottom: 24, // optional spacing below
    boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
    border:"none"
  }}
>
  {/* zero padding on CardBody — table khud spacing le lega */}
  <CardBody style={{ padding: 0 }}>
    <div style={{ overflowX: "auto" }}>
      <Table
        hover
        style={{
          margin: 0,
          minWidth: 960,
          borderCollapse: "separate",
          borderSpacing: 0,
        }}
      >
        <thead>
          <tr>
            {[
              "Contractor",
              "Company",
              "Project",
              "Status",
              "Entry Time",
              "Exit Time",
              "Duration",
              "Badge ID",
            ].map((col) => (
              <th
                key={col}
                style={{
                  padding: "14px 16px",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#6C6C6C",
                  whiteSpace: "nowrap",
                  borderBottom: "1px solid #E5E7EB",
                }}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {contractors.map((c, idx) => {
            /* shared cell style */
            const cell = {
              padding: "12px 16px",
              fontSize: 14,
              verticalAlign: "middle",
              borderBottom:
                idx === contractors.length - 1
                  ? "none"
                  : "1px solid #F2F2F2",
            };

            return (
              <tr key={c.id}>
                {/* contractor column */}
                <td style={{ ...cell }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      padding:"20px",
                      borderLeft:"none",
                      borderRight:"none"
                    }}
                  >
                    <div
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: "50%",
                        background: "#E5E7EB",
                      }}
                    />
                    <div>
                      <div
                        style={{
                          fontWeight: 600,
                          color: "#3C3C3C",
                        }}
                      >
                        {c.name}
                      </div>
                      <div
                        style={{
                          fontSize: 12,
                          color: "#6C6C6C",
                        }}
                      >
                        {c.phone}
                      </div>
                    </div>
                  </div>
                </td>

                <td style={cell}>{c.company}</td>
                <td style={cell}>{c.project}</td>

                <td style={cell}>
                  {/* status pill */}
                  <span
                    style={{
                      display: "inline-block",
                      padding: "2px 12px",
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#fff",
                      background:
                        c.status === "Inside" ? "#14A44D" : "#AEB5BC",
                      borderRadius: 12,
                      minWidth: 60,
                      textAlign: "center",
                    }}
                  >
                    {c.status}
                  </span>
                </td>

                <td style={{ ...cell, whiteSpace: "nowrap" }}>{c.entry}</td>
                <td style={{ ...cell, whiteSpace: "nowrap" }}>{c.exit}</td>
                <td style={{ ...cell, whiteSpace: "nowrap" }}>
                  {c.duration}
                </td>

                <td style={cell}>
                  <span
                    style={{
                      display: "inline-block",
                      padding: "2px 10px",
                      fontSize: 12,
                      background: "#F2F2F2",
                      borderRadius: 12,
                    }}
                  >
                    {c.badge}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  </CardBody>
</Card>
 </CardBody>

      </Card>

    </Container>
  );
}

export default ContractorManagement;
